<template>
  <v-dialog v-model="dialog" max-width="1000" max-height="1000">
    <v-card class="font-futura" :title="this.title">
      <v-card-text>
        <v-carousel hide-delimiters height="600">
          <v-carousel-item
            v-for="(item, index) in linkedFiles"
            :key="index"
            :src="'data:image/png;base64,' + item"
          ></v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          :text="$t('close')"
          variant="plain"
          @click="close"
          class="font-futura-button"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ShowLinkDialog",
  props: ["modelDialog", "link", "title"],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      linkedFiles: (state) => state.linkedFile,
    }),
    dialog: {
      get() {
        return this.modelDialog;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
